export const subDepartmentOptions = [
  [
    { label: 'Head of Department', value: 'Head of Department' },
    {
      label: 'Agriculture Marketing & Co-Operation, Secretariat',
      value: 'Agriculture Marketing & Co-Operation, Secretariat',
    },
    { label: 'Agriculture Department', value: 'Agriculture Department' },
    { label: 'Horticulture Department', value: 'Horticulture Department' },
    { label: 'Sericulture Department', value: 'Sericulture Department' },
    { label: 'Marketing Department', value: 'Marketing Department' },
    {
      label: 'Registrar of Co-Operative Societies',
      value: 'Registrar of Co-Operative Societies',
    },
    {
      label: 'Animal Husbandry, Dairy Development & Fisheries, Secretariat',
      value: 'Animal Husbandry, Dairy Development & Fisheries, Secretariat',
    },
    {
      label: 'Animal Husbandry Department',
      value: 'Animal Husbandry Department',
    },
    { label: 'Fisheries Department', value: 'Fisheries Department' },
    {
      label: 'Backward Classes Welfare, Secretariat',
      value: 'Backward Classes Welfare, Secretariat',
    },
    {
      label: 'Backward Classes Welfare Department',
      value: 'Backward Classes Welfare Department',
    },
    {
      label: 'Environment, Forest, Science & Technology, Secretariat',
      value: 'Environment, Forest, Science & Technology, Secretariat',
    },
    {
      label: 'Principal Chief Conservator of Forests',
      value: 'Principal Chief Conservator of Forests',
    },
    {
      label: 'Higher Education, Secretariat',
      value: 'Higher Education, Secretariat',
    },
    {
      label: 'Collegiate Education Department',
      value: 'Collegiate Education Department',
    },
    { label: 'State Archives', value: 'State Archives' },
    {
      label: 'Oriental Manuscripts Department',
      value: 'Oriental Manuscripts Department',
    },
    { label: 'Energy, Secretariat', value: 'Energy, Secretariat' },
    {
      label: 'Directorate of Electrical Safety',
      value: 'Directorate of Electrical Safety',
    },
    {
      label: 'Chief Engineer, Electrical Generation',
      value: 'Chief Engineer, Electrical Generation',
    },
    {
      label: 'Secondary Education Secretariat',
      value: 'Secondary Education Secretariat',
    },
    {
      label: 'School Education Department',
      value: 'School Education Department',
    },
    {
      label: 'Government Examinations Department',
      value: 'Government Examinations Department',
    },
    {
      label: 'Adult Education Department',
      value: 'Adult Education Department',
    },
    {
      label: 'Public Libraries Department',
      value: 'Public Libraries Department',
    },
    { label: 'Government Textbook Press', value: 'Government Textbook Press' },
    {
      label: 'Intermediate Education Department',
      value: 'Intermediate Education Department',
    },
    {
      label: 'Department of Economically Weaker Sections (EWS) Welfare',
      value: 'Department of Economically Weaker Sections (EWS) Welfare',
    },
    {
      label: 'Food & Civil Supplies, Secretariat',
      value: 'Food & Civil Supplies, Secretariat',
    },
    {
      label: 'Food & Civil Supplies Department',
      value: 'Food & Civil Supplies Department',
    },
    {
      label: 'Legal Metrology Department',
      value: 'Legal Metrology Department',
    },
    {
      label: 'Andhra Pradesh State Consumer Disputes Redressal Commission',
      value: 'Andhra Pradesh State Consumer Disputes Redressal Commission',
    },
    { label: 'Finance, Secretariat', value: 'Finance, Secretariat' },
    {
      label: 'Treasuries & Accounts Department',
      value: 'Treasuries & Accounts Department',
    },
    { label: 'State Audit Department', value: 'State Audit Department' },
    { label: 'Life Insurance Department', value: 'Life Insurance Department' },
    { label: 'Pay & Accounts officer', value: 'Pay & Accounts officer' },
    {
      label: 'Works Accounts Directorate',
      value: 'Works Accounts Directorate',
    },
    {
      label: 'Andhra Pradesh State Directorate of Revenue Intelligence',
      value: 'Andhra Pradesh State Directorate of Revenue Intelligence',
    },
    {
      label: 'General Administration, Secretariat',
      value: 'General Administration, Secretariat',
    },
    {
      label: 'Information & Public Relations Department',
      value: 'Information & Public Relations Department',
    },
    {
      label: 'Andhra Pradesh Public Service Commission',
      value: 'Andhra Pradesh Public Service Commission',
    },
    {
      label: 'Tribunal for Disciplinary Proceedings',
      value: 'Tribunal for Disciplinary Proceedings',
    },
    { label: 'Anti-Corruption Bureau', value: 'Anti-Corruption Bureau' },
    { label: 'Protocol Directorate', value: 'Protocol Directorate' },
    {
      label: 'Governor & Governor Secretariat',
      value: 'Governor & Governor Secretariat',
    },
    {
      label: 'Lok-Ayukta & Upa Lok-Ayukta',
      value: 'Lok-Ayukta & Upa Lok-Ayukta',
    },
    {
      label: 'Vigilance & Enforcement Directorate General',
      value: 'Vigilance & Enforcement Directorate General',
    },
    {
      label: 'Andhra Pradesh Bhavan, New Delhi',
      value: 'Andhra Pradesh Bhavan, New Delhi',
    },
    {
      label: 'Andhra Pradesh Vigilance Commission',
      value: 'Andhra Pradesh Vigilance Commission',
    },
    {
      label: 'Andhra Pradesh Human Resources Development Institute',
      value: 'Andhra Pradesh Human Resources Development Institute',
    },
    { label: 'Chief Electoral Officer', value: 'Chief Electoral Officer' },
    {
      label: 'Andhra Pradesh State Administrative Tribunal',
      value: 'Andhra Pradesh State Administrative Tribunal',
    },
    { label: 'Translations Directorate', value: 'Translations Directorate' },
    {
      label: 'Andhra Pradesh Information Commission',
      value: 'Andhra Pradesh Information Commission',
    },
    {
      label: 'Special Enforcement Bureau',
      value: 'Special Enforcement Bureau',
    },
    {
      label: 'Special Investigation Team',
      value: 'Special Investigation Team',
    },
    {
      label: 'Village Secretariats /Ward Secretariats',
      value: 'Village Secretariats /Ward Secretariats',
    },
    {
      label: 'Village Secretariats /Ward Secretariats Commissionerate',
      value: 'Village Secretariats /Ward Secretariats Commissionerate',
    },
    {
      label: 'Health, Medical & Family Welfare, Secretariat',
      value: 'Health, Medical & Family Welfare, Secretariat',
    },
    {
      label: 'Medical Education Department',
      value: 'Medical Education Department',
    },
    {
      label: 'Public Health & Family Welfare Department',
      value: 'Public Health & Family Welfare Department',
    },
    { label: 'Family Welfare Department', value: 'Family Welfare Department' },
    {
      label: 'Institute of Preventive Medicine',
      value: 'Institute of Preventive Medicine',
    },
    {
      label: 'Ayurveda, Yoga, Unani, Siddha & Homeopathy (AYUSH) Department',
      value: 'Ayurveda, Yoga, Unani, Siddha & Homeopathy (AYUSH) Department',
    },
    {
      label: 'Drugs Control Administration',
      value: 'Drugs Control Administration',
    },
    {
      label: 'Directorate of Secondary Health',
      value: 'Directorate of Secondary Health',
    },
    { label: 'Home, Secretariat', value: 'Home, Secretariat' },
    {
      label: 'Director General & Inspector General of Police',
      value: 'Director General & Inspector General of Police',
    },
    {
      label: 'Director General & Inspector General of Prisons',
      value: 'Director General & Inspector General of Prisons',
    },
    {
      label: 'Printing, Stationery & Stores Purchase Department',
      value: 'Printing, Stationery & Stores Purchase Department',
    },
    {
      label: 'Director General of State Disaster Response & Fire Services',
      value: 'Director General of State Disaster Response & Fire Services',
    },
    { label: 'Sainik Welfare Department', value: 'Sainik Welfare Department' },
    { label: 'Police Academy', value: 'Police Academy' },
    { label: 'Intelligence Department', value: 'Intelligence Department' },
    { label: 'Home Guards', value: 'Home Guards' },
    { label: 'Special Protection Force', value: 'Special Protection Force' },
    { label: 'Grey Hounds', value: 'Grey Hounds' },
    {
      label: 'Organisation of Counter Terrorist Operations (OCTOPUS)',
      value: 'Organisation of Counter Terrorist Operations (OCTOPUS)',
    },
    {
      label: 'Commissioner of Police, Visakhapatnam',
      value: 'Commissioner of Police, Visakhapatnam',
    },
    {
      label: 'Commissioner of Police, Vijayawada',
      value: 'Commissioner of Police, Vijayawada',
    },
    { label: 'Prosecutions Department', value: 'Prosecutions Department' },
    {
      label: 'Andhra Pradesh Crime Investigation Department',
      value: 'Andhra Pradesh Crime Investigation Department',
    },
    {
      label: 'Andhra Pradesh Special Police',
      value: 'Andhra Pradesh Special Police',
    },
    {
      label: 'Elite Anti-Narcotics Group for Law Enforcement(EAGLE)',
      value: 'Elite Anti-Narcotics Group for Law Enforcement(EAGLE)',
    },
    { label: 'Housing, Secretariat', value: 'Housing, Secretariat' },
    { label: 'Weaker Section Housing', value: 'Weaker Section Housing' },
    {
      label: 'Water Resources, Secretariat',
      value: 'Water Resources, Secretariat',
    },
    {
      label: 'Command Area Development Authority',
      value: 'Command Area Development Authority',
    },
    { label: 'Ground Water Department', value: 'Ground Water Department' },
    {
      label: 'Water Resources (Administration)',
      value: 'Water Resources (Administration)',
    },
    {
      label: 'Major Irrigation, Flood Control & Drainage',
      value: 'Major Irrigation, Flood Control & Drainage',
    },
    {
      label: 'Minor Irrigation Department',
      value: 'Minor Irrigation Department',
    },
    {
      label: 'N.T.R Telugu Ganga Project',
      value: 'N.T.R Telugu Ganga Project',
    },
    { label: 'Tungabhadra Board', value: 'Tungabhadra Board' },
    {
      label: 'Central Design Organisation',
      value: 'Central Design Organisation',
    },
    {
      label: 'Inter State Water Resources',
      value: 'Inter State Water Resources',
    },
    {
      label: 'Commissionerate of Tenders',
      value: 'Commissionerate of Tenders',
    },
    {
      label: 'Irrigation Projects, Kadapa',
      value: 'Irrigation Projects, Kadapa',
    },
    { label: 'Hydrology Department', value: 'Hydrology Department' },
    {
      label: 'Krishna Basin, Commissioner',
      value: 'Krishna Basin, Commissioner',
    },
    {
      label: 'Irrigation Projects, North Coastal Districts',
      value: 'Irrigation Projects, North Coastal Districts',
    },
    {
      label: 'Irrigation Projects, Ongole',
      value: 'Irrigation Projects, Ongole',
    },
    {
      label: 'Irrigation Projects, Anantapur',
      value: 'Irrigation Projects, Anantapur',
    },
    { label: 'Polavaram Project', value: 'Polavaram Project' },
    {
      label: 'Irrigation Projects, Kurnool',
      value: 'Irrigation Projects, Kurnool',
    },
    {
      label: 'Resettlement & Rehabilitation Commissionerate',
      value: 'Resettlement & Rehabilitation Commissionerate',
    },
    {
      label: 'Quality Control Wing for Andhra Region',
      value: 'Quality Control Wing for Andhra Region',
    },
    {
      label: 'Quality Control Wing for Rayalaseema Region',
      value: 'Quality Control Wing for Rayalaseema Region',
    },
    {
      label: 'Godavari Delta System, Dowlaiswaram',
      value: 'Godavari Delta System, Dowlaiswaram',
    },
    {
      label: 'Krishna Delta System, Vijayawada',
      value: 'Krishna Delta System, Vijayawada',
    },
    {
      label: 'Infrastructure & Investment, Secretariat',
      value: 'Infrastructure & Investment, Secretariat',
    },
    { label: 'State Ports Directorate', value: 'State Ports Directorate' },
    {
      label: 'Industries & Commerce, Secretariat',
      value: 'Industries & Commerce, Secretariat',
    },
    {
      label: 'Industries, Commerce & Export Promotion Department',
      value: 'Industries, Commerce & Export Promotion Department',
    },
    {
      label: 'Handlooms & Textiles Department',
      value: 'Handlooms & Textiles Department',
    },
    {
      label: 'Mines & Geology Department',
      value: 'Mines & Geology Department',
    },
    { label: 'Sugar Cane Commissioner', value: 'Sugar Cane Commissioner' },
    {
      label:
        'Information Technology, Electronics & Communications, Secretariat',
      value:
        'Information Technology, Electronics & Communications, Secretariat',
    },
    {
      label: 'Electronically Deliverable Services Directorate',
      value: 'Electronically Deliverable Services Directorate',
    },
    {
      label:
        'Labour, Factories, Boilers & Insurance Medical Services, Secretariat',
      value:
        'Labour, Factories, Boilers & Insurance Medical Services, Secretariat',
    },
    { label: 'Labour Department', value: 'Labour Department' },
    { label: 'Factories Department', value: 'Factories Department' },
    { label: 'Labour Court, Guntur', value: 'Labour Court, Guntur' },
    {
      label: 'Labour Court-cum-Industrial Tribunal, Visakhapatnam',
      value: 'Labour Court-cum-Industrial Tribunal, Visakhapatnam',
    },
    { label: 'Labour Court, Anantapur', value: 'Labour Court, Anantapur' },
    {
      label: 'Insurance Medical Services Department',
      value: 'Insurance Medical Services Department',
    },
    { label: 'Boilers Department', value: 'Boilers Department' },
    { label: 'Law, Secretariat', value: 'Law, Secretariat' },
    {
      label: 'Registrar General of High Court',
      value: 'Registrar General of High Court',
    },
    {
      label: 'Advocate General of Andhra Pradesh',
      value: 'Advocate General of Andhra Pradesh',
    },
    {
      label: 'Andhra Pradesh State Legal Services Authority',
      value: 'Andhra Pradesh State Legal Services Authority',
    },
    {
      label: 'Andhra Pradesh Judicial Academy',
      value: 'Andhra Pradesh Judicial Academy',
    },
    { label: 'Legislature Secretariat', value: 'Legislature Secretariat' },
    {
      label: 'Municipal Administration & Urban Development, Secretariat',
      value: 'Municipal Administration & Urban Development, Secretariat',
    },
    {
      label: 'Municipal Administration Department',
      value: 'Municipal Administration Department',
    },
    {
      label: 'Town & Country Planning Department',
      value: 'Town & Country Planning Department',
    },
    {
      label: 'Public Health Engineering Department',
      value: 'Public Health Engineering Department',
    },
    {
      label: 'Minorities Welfare, Secretariat',
      value: 'Minorities Welfare, Secretariat',
    },
    { label: 'Minorities Commission', value: 'Minorities Commission' },
    {
      label: 'Minorities Welfare Department',
      value: 'Minorities Welfare Department',
    },
    {
      label: 'Public Enterprises Secretariat',
      value: 'Public Enterprises Secretariat',
    },
    { label: 'Planning, Secretariat', value: 'Planning, Secretariat' },
    {
      label: 'Economics & Statistics Department',
      value: 'Economics & Statistics Department',
    },
    {
      label: 'Panchayat Raj & Rural Development, Secretariat',
      value: 'Panchayat Raj & Rural Development, Secretariat',
    },
    { label: 'Panchayat Raj Department', value: 'Panchayat Raj Department' },
    {
      label: 'Panchayat Raj Engineering Department',
      value: 'Panchayat Raj Engineering Department',
    },
    { label: 'State Election Commission', value: 'State Election Commission' },
    {
      label: 'Rural Development Department',
      value: 'Rural Development Department',
    },
    {
      label: 'Rural Water Supply Department',
      value: 'Rural Water Supply Department',
    },
    {
      label:
        'Andhra Pradesh State Institute of Rural Development & Panchyat Raj (APSIRD & PR)',
      value:
        'Andhra Pradesh State Institute of Rural Development & Panchyat Raj (APSIRD & PR)',
    },
    { label: 'Revenue, Secretariat', value: 'Revenue, Secretariat' },
    {
      label: 'Land Administration Department',
      value: 'Land Administration Department',
    },
    {
      label: 'Commercial Taxes Department',
      value: 'Commercial Taxes Department',
    },
    { label: 'Excise Department', value: 'Excise Department' },
    {
      label: 'Survey, Settlement & Land Records Department',
      value: 'Survey, Settlement & Land Records Department',
    },
    { label: 'Endowments Department', value: 'Endowments Department' },
    {
      label: 'Registration & Stamps Department',
      value: 'Registration & Stamps Department',
    },
    {
      label: 'Relief & Disaster Management Commissionerate',
      value: 'Relief & Disaster Management Commissionerate',
    },
    {
      label: 'Andhra Pradesh Value Added Tax Appellate Tribunal, Visakhapatnam',
      value: 'Andhra Pradesh Value Added Tax Appellate Tribunal, Visakhapatnam',
    },
    {
      label: 'Department of Real Time Governance',
      value: 'Department of Real Time Governance',
    },
    {
      label: 'Department of Skills Development & Training, Secretariat',
      value: 'Department of Skills Development & Training, Secretariat',
    },
    {
      label: 'Employment & Training Department',
      value: 'Employment & Training Department',
    },
    {
      label: 'Technical Education Department',
      value: 'Technical Education Department',
    },
    {
      label: 'Social Welfare, Secretariat',
      value: 'Social Welfare, Secretariat',
    },
    { label: 'Social Welfare Department', value: 'Social Welfare Department' },
    {
      label: 'Social Welfare Residential Educational Institutions Society',
      value: 'Social Welfare Residential Educational Institutions Society',
    },
    {
      label: 'Tribal Welfare, Secretariat',
      value: 'Tribal Welfare, Secretariat',
    },
    { label: 'Tribal Welfare Department', value: 'Tribal Welfare Department' },
    {
      label: 'Tribal Welfare Engineering Department',
      value: 'Tribal Welfare Engineering Department',
    },
    {
      label: 'Tribal Welfare Residential Educational Institutions Society',
      value: 'Tribal Welfare Residential Educational Institutions Society',
    },
    {
      label: 'Transport, Roads & Buildings, Secretariat',
      value: 'Transport, Roads & Buildings, Secretariat',
    },
    {
      label: 'Administration, State Roads & Road Safety Works (RSW), ENC (R&B)',
      value: 'Administration, State Roads & Road Safety Works (RSW), ENC (R&B)',
    },
    { label: 'Transport Department', value: 'Transport Department' },
    { label: 'Buildings Department', value: 'Buildings Department' },
    {
      label:
        'Core Network Roads (CRN), Road Development Corporation (RDC) & Public Private Partnership (PPP) Department',
      value:
        'Core Network Roads (CRN), Road Development Corporation (RDC) & Public Private Partnership (PPP) Department',
    },
    {
      label: 'Rural Roads, ENC (Roads & Buildings)',
      value: 'Rural Roads, ENC (Roads & Buildings)',
    },
    { label: 'Electrical Chief Engineer', value: 'Electrical Chief Engineer' },
    {
      label: 'National Highways & Central Road Funds Department',
      value: 'National Highways & Central Road Funds Department',
    },
    {
      label: 'Public Transport Department',
      value: 'Public Transport Department',
    },
    {
      label:
        'Women, Children, Differently Abled & Senior Citizens, Secretariat',
      value:
        'Women, Children, Differently Abled & Senior Citizens, Secretariat',
    },
    {
      label: 'Women Development & Child Welfare Department',
      value: 'Women Development & Child Welfare Department',
    },
    {
      label:
        'Department for Welfare of Differently Abled, Transgender & Senior Citizens',
      value:
        'Department for Welfare of Differently Abled, Transgender & Senior Citizens',
    },
    {
      label: 'Juvenile Welfare Department',
      value: 'Juvenile Welfare Department',
    },
    {
      label: 'Youth Advancement, Tourism & Culture, Secretariat',
      value: 'Youth Advancement, Tourism & Culture, Secretariat',
    },
    {
      label: 'Cultural Affairs Department',
      value: 'Cultural Affairs Department',
    },
    { label: 'Tourism Department', value: 'Tourism Department' },
    { label: 'Youth Services Department', value: 'Youth Services Department' },
    {
      label: 'National Cadet Corps (N.C.C) Department',
      value: 'National Cadet Corps (N.C.C) Department',
    },
    {
      label: 'Sports Authority of Andhra Pradesh (SAAP)',
      value: 'Sports Authority of Andhra Pradesh (SAAP)',
    },
    {
      label: 'Archaeology & Museums Department',
      value: 'Archaeology & Museums Department',
    },
    {
      label: 'Other',
      value: 'Other',
    },
  ],
];
